import React from 'react';
import { Settings } from 'lucide-react';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger,
} from '../ui/dropdown-menu';

export const PaymentToolsMenu = ({ onPreview, onBackfill, onIgnoreList }) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <button type="button" data-testid="payment-tools-menu-btn" title="Tools"
        className="p-2 border rounded-lg hover:bg-slate-50 text-slate-600">
        <Settings className="w-4 h-4" />
      </button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end">
      <DropdownMenuItem data-testid="tools-preview" onSelect={onPreview}>Preview last 60 days</DropdownMenuItem>
      <DropdownMenuItem data-testid="tools-backfill" onSelect={onBackfill}>Backfill history</DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem data-testid="tools-ignore-list" onSelect={onIgnoreList}>Settings: ignored payees</DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);
